var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Neuer Download"}},[_c('download-form',{attrs:{"download":_vm.download,"submit-label":"Neuen Download anlegen","form-submitted":_vm.saveDownload,"mode":"new"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }